import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import { useCheckSignIn, useCountDownRedirection } from "./FinishSignInPage.hooks";
import { useCreateUser } from "components/User";

export const FinishSignInPage = () => {
  const { result, error, isChecking } = useCheckSignIn();
  useCreateUser(result?.user);
  const { remain, redirection } = useCountDownRedirection(!!result);

  return (
    <Container>
      <Row>
        <Col>
          <h2>로그인 확인</h2>
          <p>
            {isChecking && "로그인 체크 중..."}
            {error && error.message}
            {result && `${result.user.email}님 환영합니다. ${remain}초 후에 기존 페이지로 이동합니다.`}
          </p>
          {result && <Link to={redirection}>지금 이동</Link>}
        </Col>
      </Row>
    </Container>
  )
}
